import r from "./component-library284.js";
/* empty css                     */
import n from "./component-library98.js";
var c = function() {
  var e = this, a = e._self._c, s = e._self._setupProxy;
  return a("div", { staticClass: "variant-selector-basic", attrs: { role: "radiogroup", "aria-label": `${e.displayName} auswählen` } }, [e._l(e.variants, function(t, i) {
    return [a(s.LinkButton, { key: i + t.name, staticClass: "variant-selector-basic__item", attrs: { tag: "button", type: "button", role: "radio", "aria-checked": t.active ? "true" : "false", tabindex: e.isAccessible ? void 0 : -1, title: `${e.displayName}: ${t.name}`, "aria-label": `${e.displayName}: ${t.name}`, secondary: t.active, outline: !t.active, checked: t.active, "small-padding": "" }, on: { click: function(m) {
      return e.$emit("select-variant", { variant: t });
    } } }, [a("span", [e._v(" " + e._s(t.name) + " ")])])];
  })], 2);
}, o = [], l = /* @__PURE__ */ n(
  r,
  c,
  o,
  !1,
  null,
  "d3382ba3"
);
const f = l.exports;
export {
  f as default
};
